export default __webpack_public_path__ + "static/media/loader.9fc0b3df.svg";